module.exports = __webpack_public_path__ + "static/img/certification.cff3694.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/certification.png
// module id = G1rJ
// module chunks = 2